import React, { useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { ViewPractice } from "../Components/Practice/viewpractice";
import { ViewUsers } from "../Components/Users/ViewUser";
import { AddUser } from "../Components/Users/AddUser";
import { ViewServices } from "../Components/Services/viewServices"; // ✅ correct casing
import { SetUpPractice } from "../Components/Practice/SetupPractice";
import TemplateList from "../Components/Templates/TemplateList";
import { AddTemplate } from "../Components/Templates/AddTemplate";
import { BankingPayments } from "../Components/BankingPayments/BankingPayments";
import { AddBanking } from "../Components/BankingPayments/AddBankingPayments";
import { Comms } from "../Components/Communications/Comms";
import { ViewOnlineBookings } from "../Components/Practice/ViewOnlineBookings";
import AddEditOnlineBookings from "../Components/Practice/AddEditOnlineBookings";
import { ViewPeople } from "../Components/People/ViewPeople"; // ✅ new import
import { ViewIntakeSettings } from "../Components/Practice/ViewIntakeSettings";

export function Practice() {
  const [activeSection, setActiveSection] = useState("practice");
  const [hoveredSection, setHoveredSection] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [addServiceTrigger, setAddServiceTrigger] = useState(0); // ✅ trigger for inline Add
  const [addPeopleTrigger, setAddPeopleTrigger] = useState(0);
  const handleRefresh = () => setRefresh((prev) => !prev);

  const sidebarItems = [
    { key: "practice", label: "Practice Information" },
    { key: "users", label: "User Management" },
    { key: "services", label: "Services Management" },
    { key: "banking", label: "Banking & Payments" },
    {
      key: "reminders",
      label: "Communications",
      children: [
        { key: "sms", label: "SMS Reminders" },
        { key: "email", label: "Email Reminders" },
        { key: "accounts", label: "Financial Emails" },
      ],
    },
    { key: "templates", label: "Template Management" },
    { key: "people", label: "People Management" },
    { key: "calendar", label: "Online Bookings" },
    { key: "intake", label: "Intake Form" },
  ];

  function renderHeader() {
    let title = "";
    let RightSlot = null;

    switch (activeSection) {
      case "practice":
        title = "PRACTICE INFORMATION";
        RightSlot = () => <SetUpPractice onPracticeUpdate={handleRefresh} />;
        break;
      case "users":
        title = "USER MANAGEMENT";
        RightSlot = () => <AddUser onUserUpdate={handleRefresh} />;
        break;
      case "services":
        title = "SERVICES MANAGEMENT";
        // ⬇️ just a button that signals ViewServices to open inline Add
        RightSlot = () => (
          <Button
            variant="primary"
            className="w-100"
            onClick={() => setAddServiceTrigger((n) => n + 1)}
          >
            Add Service
          </Button>
        );
        break;
      case "templates":
        title = "TEMPLATE MANAGEMENT";
        RightSlot = () => <AddTemplate onTemplateUpdate={handleRefresh} />;
        break;
      case "banking":
        title = "BANKING & PAYMENTS";
        RightSlot = () => <AddBanking onBankingUpdate={handleRefresh} />;
        break;
      case "people":
        title = "PEOPLE MANAGEMENT";
        RightSlot = () => (
          <Button
            variant="primary"
            className="w-100"
            onClick={() => setAddPeopleTrigger((n) => n + 1)}
          >
            Add Person
          </Button>
        );
        break;
      case "calendar":
        title = "CALENDAR & APPOINTMENTS";
        RightSlot = () => (
          <AddEditOnlineBookings onBookingUpdate={handleRefresh} />
        );
        break;
      case "reminders":
      case "sms":
      case "email":
      case "accounts":
        title = "COMMUNICATIONS";
        break;
      case "intake":
        title = "INTAKE FORM SETTINGS";
        break;
      default:
        title = "Practice Information";
        break;
    }

    return (
      <Container fluid className="bg-white shadow-sm pt-3 pb-3 rounded">
        <Row className="align-items-center justify-content-center g-0">
          <Col xs={10} className="text-start">
            <h5 className="text-primary mb-1 ms-4 fw-normal">{title}</h5>
          </Col>
          <Col xs={2} className="text-end">
            {RightSlot && <RightSlot />}
          </Col>
        </Row>
      </Container>
    );
  }

  function renderContent() {
    switch (activeSection) {
      case "practice":
        return (
          <ViewPractice refresh={refresh} onPracticeUpdate={handleRefresh} />
        );
      case "users":
        return <ViewUsers refresh={refresh} onUserUpdate={handleRefresh} />;
      case "services":
        return (
          <ViewServices
            refresh={refresh}
            onServiceUpdate={handleRefresh}
            addTrigger={addServiceTrigger} // ✅ pass trigger down
          />
        );
      case "templates":
        return (
          <TemplateList refresh={refresh} onTemplateEdit={handleRefresh} />
        );
      case "banking":
        return (
          <BankingPayments refresh={refresh} onBankingUpdate={handleRefresh} />
        );
      case "calendar":
        return (
          <ViewOnlineBookings
            refresh={refresh}
            onOnlineBookingUpdate={handleRefresh}
          />
        );
      case "sms":
      case "email":
      case "accounts":
        return <Comms initialTab={activeSection} />;
      case "intake":
        return <ViewIntakeSettings refresh={refresh} onUpdate={handleRefresh} />;
      case "people":
        return (
          <ViewPeople
            refresh={refresh}
            onPeopleUpdate={handleRefresh}
            addTrigger={addPeopleTrigger}
          />
        );
      default:
        return <ViewPractice />;
    }
  }

  return (
    <div className="ms-1" style={{ marginTop: "75px" }}>
      {renderHeader()}
      <Container fluid>
        <Row className="g-0">
          <Col md={2} className="pt-3 g-0">
            <Container className="bg-white vh-100 shadow-sm g-0 p-3 rounded">
              <div className="text-center mb-3">
                {sidebarItems.map((item) => (
                  <div
                    key={item.key}
                    onMouseEnter={() =>
                      item.children && setHoveredSection(item.key)
                    }
                    onMouseLeave={() =>
                      item.children && setHoveredSection(null)
                    }
                  >
                    <Button
                      variant={
                        activeSection === item.key
                          ? "primary"
                          : "outline-primary"
                      }
                      className="w-100 text-start mb-1"
                      onClick={() => {
                        if (item.key === "reminders") setActiveSection("sms");
                        else setActiveSection(item.key);
                      }}
                    >
                      {item.label}
                    </Button>

                    {hoveredSection === item.key && item.children && (
                      <div className="ms-3 mt-1 mb-1">
                        {item.children.map((sub) => (
                          <Button
                            key={sub.key}
                            variant={
                              activeSection === sub.key
                                ? "primary"
                                : "outline-secondary"
                            }
                            size="sm"
                            className="w-100 text-start mb-1 rounded-0 fw-normal"
                            onClick={() => setActiveSection(sub.key)}
                          >
                            {sub.label}
                          </Button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </Container>
          </Col>

          <Col md={10}>
            <Container className="pt-3 bg-transparent pb-3 mb-3 rounded">
              {renderContent()}
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
